import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EMPTY, expand, Observable, reduce, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Calls to graph succeed becaue the MSAL http interceptor adds the bearer token

export type ProfileType = {
  givenName?: string;
  surname?: string;
  userPrincipalName?: string;
  id?: string;
};

type GroupsType = {
  '@odata.nextLink'?: string;
  value?: Array<{ id: string }>;
};

@Injectable({
  providedIn: 'root'
})
export class MicrosoftGraphService {

  private _profile$!: Observable<ProfileType>;

  private _groups$!: Observable<Array<string>>;

  // Only IDs are returned for memberOf because User.Read permissions only include minimal data for groups
  // Group.Read.All would return names and other group data, but is too permissive
  private groupsEndpoint = environment.apiConfig.graphUri + '/transitiveMemberOf?$top=50';

  private avatarEndpoint = environment.apiConfig.graphUri + '/photo/$value';

  constructor(private http: HttpClient) {}

  private getGroupData(from = this.groupsEndpoint): any {
    return this.http.get(from);
  }

  // shareReplay pattern gets data from server one time, and caches in service

  get profile(): Observable<ProfileType> {
    if (!this._profile$) {
      this._profile$ = this.http
        .get(environment.apiConfig.graphUri)
        .pipe(shareReplay({ refCount: true, bufferSize: 1 }));
    }
    return this._profile$;
  }

  get groups(): Observable<Array<string>> {
    if (!this._groups$) {
      this._groups$ = this.getGroupData().pipe(
        expand((groupData: GroupsType) => {
          const nextLink = groupData['@odata.nextLink'];
          return nextLink ? this.getGroupData(nextLink) : EMPTY;
        }),
        reduce((groupIds: string[], groupData: GroupsType) => {
          return groupIds.concat(
            groupData.value?.map((group) => group.id) || []
          );
        }, []),
        shareReplay({ refCount: true, bufferSize: 1 })
      );
    }
    return this._groups$;
  }

  getAvatar() {
    return this.http.get(this.avatarEndpoint, {responseType: "arraybuffer"});
  }
  
}
